var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTicket(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 14C0 6.26801 6.26801 0 14 0H25.9934C33.7254 0 39.9934 6.26801 39.9934 14V25.9934C39.9934 33.7254 33.7254 39.9934 25.9934 39.9934H14C6.26801 39.9934 0 33.7254 0 25.9934V14Z",
    fill: "#ECFEFF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8028_359)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.6647 17.4971C12.3276 17.4971 12.9634 17.7604 13.4321 18.2292C13.9009 18.698 14.1643 19.3337 14.1643 19.9967C14.1643 20.6596 13.9009 21.2954 13.4321 21.7642C12.9634 22.2329 12.3276 22.4963 11.6647 22.4963V24.1627C11.6647 24.6046 11.8402 25.0285 12.1527 25.341C12.4653 25.6535 12.8891 25.829 13.3311 25.829H26.6622C27.1042 25.829 27.528 25.6535 27.8405 25.341C28.153 25.0285 28.3286 24.6046 28.3286 24.1627V22.4963C27.6657 22.4963 27.0299 22.2329 26.5611 21.7642C26.0924 21.2954 25.829 20.6596 25.829 19.9967C25.829 19.3337 26.0924 18.698 26.5611 18.2292C27.0299 17.7604 27.6657 17.4971 28.3286 17.4971V15.8307C28.3286 15.3887 28.153 14.9649 27.8405 14.6524C27.528 14.3399 27.1042 14.1643 26.6622 14.1643H13.3311C12.8891 14.1643 12.4653 14.3399 12.1527 14.6524C11.8402 14.9649 11.6647 15.3887 11.6647 15.8307V17.4971Z",
    stroke: "#0092B8",
    strokeWidth: 1.66639,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8298 14.1643V15.8307",
    stroke: "#0092B8",
    strokeWidth: 1.66639,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8298 24.1627V25.8291",
    stroke: "#0092B8",
    strokeWidth: 1.66639,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8298 19.1635V20.8299",
    stroke: "#0092B8",
    strokeWidth: 1.66639,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8028_359"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.9967,
    height: 19.9967,
    fill: "white",
    transform: "translate(9.99829 9.99835)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTicket);
export default __webpack_public_path__ + "static/media/ticket.620e51510a52dd53bedaa50cfbced496.svg";
export { ForwardRef as ReactComponent };